import * as React from "react";
import { Prestup } from "common/api/Evidence/Clenove/Prestupy";
import Stav from "./Stav";

import ZakladniUdaje from "./ZakladniUdaje";
import SpravniPoplatek from "./SpravniPoplatek";
import Odstupne from "./Odstupne";
import PotvrzeniIC from "./PotvrzeniIC";
import Stornovani from "./Stornovani";

interface ViewProps {
    prestup: Prestup;
    clenId?: number;
    klubId?: number;
    setPrestup: (prestup: Prestup) => void;
}

class View extends React.PureComponent<ViewProps>{

    render() {
        const { prestup, setPrestup, clenId, klubId } = this.props;

        const dtProps = {
            prestup: prestup,
            setPrestup: setPrestup,
            je_to_clen: (prestup && prestup.clen_id === clenId),
            prest_do_divize: (prestup && !prestup.nov_klub_id),
            je_to_puv_klub: (prestup && prestup.puv_klub_id === klubId),
            je_to_nov_klub: (prestup && prestup.nov_klub_id && prestup.nov_klub_id === klubId),

        }
        return <div>
            <Stav stav={prestup.stav} terminOdstupneho={prestup.odst_termin} />
            <PotvrzeniIC {...dtProps} />
            <Stornovani {...dtProps} />
            <ZakladniUdaje {...dtProps} />
            <SpravniPoplatek {...dtProps} />
            <Odstupne {...dtProps} />
        </div>
    }
}

export default View;